<template>
  <div class="home">
    <b-container fluid>
      <CompleteAnalytics v-if="displayAnalytics" class="marginal" :videoID="videoID"></CompleteAnalytics>
    </b-container>
  </div>
</template>

<script>
import CompleteAnalytics from '@/components/analytics/CompleteAnalytics.vue';

export default {
  name: 'AnalyticsVideo',
  components: {
    CompleteAnalytics,
  },
  data() {
      return {
          videoID: "*",
          displayAnalytics: false
      }
  },
  mounted() {
      this.videoID = this.$route.params['videoID'];
      this.displayAnalytics = true;
  }
}
</script>